/**
 * Componente de Logo
 * Logo reutilizável usado em todo o aplicativo
 * Adapta-se automaticamente ao contexto da aplicação
 */

import { ContextIcon } from './ContextIcon'
import { useContextKey } from '@/contexts/UnitContext'

import { UnitContext } from '@/lib/types';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
  context?: UnitContext
}

const sizeMap = {
  sm: { container: 'h-12 w-12', icon: 'h-6 w-6' },
  md: { container: 'h-16 w-16', icon: 'h-8 w-8' },
  lg: { container: 'h-20 w-20', icon: 'h-10 w-10' },
}

export function Logo({ size = 'lg', className = '', context }: LogoProps) {
  const sizes = sizeMap[size]

  // Hook sempre chamado incondicionalmente (Rules of Hooks)
  const contextFromHook = useContextKey()
  // Prop > env default embutido no hook > 'farm'
  const appContext = (context || contextFromHook || 'farm') as UnitContext

  return (
    <div className={`flex ${sizes.container} items-center justify-center rounded-full bg-emerald-100 dark:bg-emerald-900/30 shadow-lg ${className}`}>
      <ContextIcon context={appContext} className={`${sizes.icon} text-emerald-600 dark:text-emerald-400`} />
    </div>
  )
}
